export default {
    SET_ARTICLES: (state, articles) => {
        state.articles = articles
    },

    SET_ACTIVE_ARTICLE: (state, activeArticle) => {
        state.activeArticle = activeArticle
    },

    SET_PAGINATION: (state, pagination) => {
        state.pagination = pagination
    },

    SET_LOAD: (state, isLoaded) => {
        state.isLoaded = isLoaded
    },

    SET_FILTERS: (state, filters) => {
        state.filters = filters
    },

    RESET_ARTICLE_FILTERS: (state) => {
        state.filters = {
            fromDate: null,
            toDate: null,
            shown: null,
            phone: null,
            scope: null
        }
    }
}
